import { render, staticRenderFns } from "./TargetsSection.vue?vue&type=template&id=b6bddcb2&scoped=true&"
import script from "./TargetsSection.vue?vue&type=script&lang=js&"
export * from "./TargetsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bddcb2",
  null
  
)

export default component.exports